import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoanStepperService } from '../../services/loan-stepper.service';
import { PosPublicApiService } from '../../../services/pos-public-api.service';
import { ActivatedRoute } from '@angular/router';
import { WithDestroy } from '@lib/shared';
import { switchMap, takeUntil } from 'rxjs/operators';

declare let jQuery: any;

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  providers: [LoanStepperService]
})
export class LayoutComponent extends WithDestroy() implements OnInit, OnDestroy {
  public mobileNavToggle = false;
  public mobileInfoToggle = false;
  public reviewTooltip = false;
  public currLoanData: any;
  public loggedInBorr: any;

  constructor(private publicService: PosPublicApiService, private route: ActivatedRoute, private loanStepperService: LoanStepperService) {
    super();
  }

  ngOnInit() {
    this.publicService.openRightInfoSubject.subscribe((openRight: boolean) => {
      if (openRight) {
        this.mobileInfoToggle = true;
      }
    });
    this.route.data
      .pipe(
        switchMap((data: any) => {
          return data.loan.valueChanges;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((loan: any) => {
        if (loan) {
          this.currLoanData = loan;
          this.loggedInBorr = loan.Borrowers.find((borr) => borr.id === loan.loggedInBorrId);
        }
      });

    this.loanStepperService.uiStateData$.subscribe((res) => {
      this.reviewTooltip = res.skipReviewTooltip ? false : true;
    });
  }

  public onActivate(componentRef) {
    this.mobileNavToggle = false;
    this.mobileInfoToggle = false;
    jQuery('.content-wrapper').scrollTop(0);
  }

  /**
   * Method for mobile view to set 'open' class on left nav or right whichever to open
   */
  public openSideBar(openLeft: boolean) {
    this.mobileNavToggle = openLeft;
    this.mobileInfoToggle = !openLeft;
  }

  public closeTooltip() {
    this.loanStepperService.setReviewTooltipFlag();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
